import { render } from "./IsAuthenticated.vue?vue&type=template&id=d36131dc&ts=true"
import script from "./IsAuthenticated.vue?vue&type=script&lang=ts"
export * from "./IsAuthenticated.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/kun/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__